import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFetch from "./useFetch";
import { userActions } from "../store/user-slice";
import {  useNavigate } from "react-router-dom";

export default function useAuthorized() {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);

  let user = useSelector((state) => state.user.user);
  let navigate = useNavigate();

  const { get } = useFetch();

  let dispatch = useDispatch();

  const getUser = () => {
    get(
      "/user",
      null,
      () => {
        setIsAuthorized(false);
        setIsAdmin(false);
        dispatch(userActions.setUser(null));
        navigate("/login");
      },
      (res) => {
        dispatch(userActions.setUser(res));
        setIsAuthorized(true);
        setIsAdmin(res.is_admin);
      },
    );
  };

  useEffect(() => {
    if (user) {
      setIsAuthorized(true);
      setIsAdmin(user.is_admin);
    } else {
      getUser();
    }
  }, []);

  return { isAuthorized, isAdmin };
}
